import { hardRedirectTo } from '../../../../utils';

/**
 * Redirect the user to GitHub's User OAuth web flow. Once complete, they'll
 * be directed back to the GitHub App settings page.
 */
export function connectToGitHub(redirectPage: 'settings' | 'quick-import') {
  if (redirectPage === 'quick-import') {
    hardRedirectTo('/api/services/github-app/authorize?next=/projects/import/github-app');
  }
  if (redirectPage === 'settings') {
    hardRedirectTo('/api/services/github-app/authorize?next=/account/settings/integrations/github-app');
  }
}
